import { Button, ButtonGroup, TextField } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { addBroker,reset } from "../../redux/features/broker.features";
import LoadingScreen from '../LoadingScreen/LoadingScreen' 

const initialValues = {
  firstName: "",
  lastName: "",
  homeAddress: "",
  businessAddress: "",
  country: "Sri Lanka",
  city: "Beruwala",
  mobile: "",
  email: "",
  status: "Active",
};



const BrokerEntry = () => {
  const dispatch = useDispatch()
  const [values, setValues] = useState(initialValues);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

   
  let brokerState = useSelector((state) => {
    return state.brokerReducer;
  });
  let { brokers, loading , errorMessage , successMessage} = brokerState;

  return (
    <>
    {
      errorMessage !=="" || successMessage !=="" ? (<LoadingScreen reset={()=>dispatch(reset())} errorMessage={errorMessage} successMessage={successMessage} />):
     (  
      <div className="row">       
      <div className="col-12">
        <div className="card">
          <div className="row card__body">
            <div className="col-6">
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="Broker id"
                defaultValue=""
                color="warning"
                margin="dense"
                name="brokerId"
                value={values.brokerId}
                disabled
                onChange={handleChange}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="firstName"
                placeholder="Blue Sapphire "
                name="firstName"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.firstName}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                rows={4}
                id="outlined-required"
                label="lastName"
                placeholder="lastName"
                defaultValue=""
                color="warning"
                name="lastName"
                value={values.lastName}
                onChange={handleChange}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                multiline
                rows={4}
                id="outlined-required"
                label="homeAddress"
                placeholder="homeAddress"
                defaultValue=""
                color="warning"
                name="homeAddress"
                value={values.homeAddress}
                onChange={handleChange}
              />
              
            </div>
            <div className="col-6">
              

              
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                type="number"
                id="outlined-required"
                label="mobile"
                placeholder="mobile"
                name="mobile"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.mobile}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                type="email"
                id="outlined-required"
                label="email"
                placeholder="email"
                name="email"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.email}
              />
                <CustomSelectBox
                items={["Active", "DeActive"]}
                onChange={handleChange}
                title="Status"
                name="status"
                value={values.status}
              />
              <div style={{marginBottom:150}}></div>
              
              <ButtonGroup
               
                fullWidth
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button color="warning">Cancel</Button>

                <Button onClick={e=>dispatch(addBroker(values))} color="success">Save</Button>
              </ButtonGroup>
            </div>
          </div>
        </div>
      </div>
    </div>)
    }
  </>
  );
};

export default BrokerEntry;
